import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@xxtract/ui';

type EmptyStateKind = 'intake' | 'orders' | 'dataQuality' | 'settings';

interface EmptyStatePageProps {
  kind: EmptyStateKind;
}

const contentKeys: Record<EmptyStateKind, { title: string; description: string }> = {
  intake: { title: 'intake.empty.title', description: 'intake.empty.description' },
  orders: { title: 'orders.empty.title', description: 'orders.empty.description' },
  dataQuality: { title: 'dataQuality.empty.title', description: 'dataQuality.empty.description' },
  settings: { title: 'management.settings.title', description: 'management.settings.description' },
};

export function EmptyStatePage({ kind }: EmptyStatePageProps) {
  const { t } = useTranslation();
  const content = contentKeys[kind];
  const testId = `${kind}-empty-state`;

  return (
    <section data-testid={testId} aria-labelledby={`${kind}-empty-title`} className="max-w-xl">
      <Card>
        <CardHeader>
          <CardTitle id={`${kind}-empty-title`}>{t(content.title)}</CardTitle>
          <CardDescription>{t(content.description)}</CardDescription>
        </CardHeader>
        <CardContent>
          {kind === 'intake' ? (
            <Link to="/intake/new" className="inline-flex h-9 items-center rounded-[var(--radius-control)] bg-[var(--primary)] px-4 text-sm font-medium text-white hover:bg-[var(--primary-hover)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--secondary)]">
              {t('intake.empty.cta')}
            </Link>
          ) : (
            <p role="status" className="text-sm text-[var(--foreground-muted)]">{t('common.comingSoon')}</p>
          )}
        </CardContent>
      </Card>
    </section>
  );
}
